import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Back")
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  style: {"font-weight":"normal"}
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Export")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("View printable report")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Add Additional information")
const _hoisted_7 = { class: "flex-cont" }
const _hoisted_8 = { class: "tags-table" }
const _hoisted_9 = { class: "reports-table" }
const _hoisted_10 = /*#__PURE__*/_createVNode("h2", null, "Reports", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("i", {
  style: {"margin-left":"10px"},
  class: "el-icon-top-right"
}, null, -1)
const _hoisted_12 = {
  key: 1,
  style: {"height":"100px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_link = _resolveComponent("el-link")
  const _component_el_card = _resolveComponent("el-card")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_el_button, {
      type: "info",
      icon: "el-icon-arrow-left",
      onClick: _ctx.routeBack
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["onClick"]),
    (_ctx.fetchState === _ctx.FetchStates.FETCHED)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("h1", null, _toDisplayString(_ctx.crashFile?.title), 1),
          _createVNode("h3", null, [
            (_ctx.crashFile)
              ? (_openBlock(), _createBlock("span", _hoisted_3, " Created on " + _toDisplayString(_ctx.convertDateString(
            _ctx.crashFile?.date_created ?? '',
            _ctx.userPrefs?.timezone ?? 0,
          )), 1))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_el_button, {
            icon: "el-icon-download",
            onClick: _ctx.downloadCrashFile,
            type: "primary"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            icon: "el-icon-printer",
            onClick: _ctx.printCrashFile
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["onClick"]),
          _withDirectives(_createVNode(_component_el_button, {
            icon: "el-icon-plus",
            onClick: _ctx.AddAdditionalReport
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["onClick"]), [
            [_vShow, _ctx.canAddAdditionalReport()]
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode(_component_el_table, {
                data: _ctx.tagData(_ctx.crashFile, _ctx.orgMap),
                border: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "name",
                    label: "Key"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "value",
                    label: "Value"
                  })
                ]),
                _: 1
              }, 8, ["data"])
            ]),
            _createVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_el_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table, {
                    data: _ctx.crashFile?.reports,
                    stripe: "",
                    "default-expand-all": true
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        prop: "title",
                        label: "Title"
                      }, {
                        default: _withCtx(({row}) => [
                          _createVNode(_component_el_link, {
                            href: `/#/reports/${row._id}`
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.overRideTitle(row.title)), 1)
                            ]),
                            _: 2
                          }, 1032, ["href"]),
                          _createVNode("a", {
                            href: `/#/reports/${row._id}`,
                            target: "_blank"
                          }, [
                            _hoisted_11
                          ], 8, ["href"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "date_created",
                        label: "Created",
                        sortable: "custom"
                      }, {
                        default: _withCtx(({row}) => [
                          _createTextVNode(_toDisplayString(_ctx.convertDateString(row.date_created, _ctx.userPrefs?.timezone)), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["data"])
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _withDirectives((_openBlock(), _createBlock("div", _hoisted_12, null, 512)), [
          [_directive_loading, true]
        ])
  ], 64))
}